import KendoNotification from '../KendoNotification'
import KendoTooltip from '../KendoTooltip'

let KendoPopupsInstaller = class {
    static install(Vue) {
        Vue.component(KendoNotification.name, KendoNotification)
        Vue.component(KendoTooltip.name, KendoTooltip)
    }
}

export default KendoPopupsInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(KendoPopupsInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/kendo-popups-installer/index.js